export default "__VITE_ASSET__Dk2mGNk4__"